var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.02448 8L6.20179 5.17731C5.93247 4.90799 5.93247 4.47132 6.20179 4.20199C6.47112 3.93267 6.90779 3.93267 7.17711 4.20199L10.4875 7.51234C10.7568 7.78167 10.7568 8.21833 10.4875 8.48766L7.17711 11.798C6.90779 12.0673 6.47112 12.0673 6.20179 11.798C5.93247 11.5287 5.93247 11.092 6.20179 10.8227L9.02448 8Z",
    fill: "#3F3356"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.77b03d27124bee9ddd3b4964c0f1e0f9.svg";
export { ForwardRef as ReactComponent };